import * as IOGateway from './main.ts';

export { IOGateway };

export default IOGateway.Factory;
